<div class="card mb-1">
	<div class="card-header">{{label}}</div>
	<div class="card-body">
		<input type="text" class="form-control form-control-sm" [(ngModel)]="selectedResult" [typeahead]="searchOptions" (typeaheadOnSelect)="onAdd($event.item)" typeaheadOptionField="label" [name]="label + '_search'" placeholder="Search and Add" *ngIf="searchOptions.length > 0" />
	</div>
	<div [class]="'card-body border-top limited-height-' + selectionHeightCssName">
		<div class="custom-controls-stacked">
			<div *ngFor="let option of searchOptions" (click)="toggleResult(option)" class="custom-control custom-checkbox">
				<input type="checkbox" [checked]="option.checked" [name]="label + '-' + option.value" class="custom-control-input" />
				<label class="custom-control-label">{{ option.label }}</label>
			</div>
		</div>
	</div>
</div>
<div class="card">
	<div class="card-header">
		Selected {{label}} -&nbsp;
		<app-badge badgeType="primary">
			{{ selectedOptionsUi.length }}
		</app-badge>
	</div>
	<div [class]="'card-body limited-height-' + resultsHeightCssName">
		<div class="py-1 px-1" *ngFor="let option of selectedOptionsUi">
			<a class="pull-right float-right text-danger" href="javascript: void(0)" (click)="onRemove(option)">
				<i class="fas fa-times"></i>
			</a>
			<span>{{ option.label }}</span>
		</div>
	</div>
</div>